<template>
    <div class="list-mode-group align-items-center sort-group-container">
        <label for="list-mode-order" class="select-label">Tri</label>
        <div class="custom-select small">
            <div class="select-container">
                <select name="list-mode-order" id="list-mode-order" v-model="sortMode">
                    <option value="pertinence" selected>Pertinence</option>
                    <option value="alpha">Titre</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script setup>

import { ref, watch, onMounted } from "vue";

//EMIT
const emit = defineEmits( [ "change-sort-mode" ] );

//REF
let sortMode = ref( "" )

//METHODS
function mounted ()
{
    sortMode.value = localStorage.getItem( "amelio.sortMode" ) ?? "pertinence";
}

//WATCH
watch( () => sortMode.value, ( newVal, oldVal ) => emit( 'change-sort-mode', newVal ) );


//LIFECYCLE
onMounted( mounted );

</script>

<style scoped>

</style>
